import React, { useContext } from 'react';
import { Container, Grid, Card, CardContent, Typography, Button } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import GroupIcon from '@mui/icons-material/Group';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import CategoryIcon from '@mui/icons-material/Category'; // variants
import WidgetsIcon from '@mui/icons-material/Widgets';   // generic
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import BackToDashboard from "../common/BackToAdminDashboard.js";  
import FeedbackIcon from "@mui/icons-material/Feedback";

const AdminDashboard = () => {
  const { t } = useTranslation();
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleNavigation = (path) => navigate(path);

  return (
    <Container sx={{ mt: 4 }}>
      {/* <BackToDashboard dashboardPath="/admin/dashboard" />   */}
      <Typography variant="h4" gutterBottom>
        {t("welcome_to_admin_dashboard")}
      </Typography>
      <Grid container spacing={3}>


<Grid item xs={12} sm={6} md={4}>
  <Card sx={{ textAlign: "center", boxShadow: 4 }}>
    <CardContent>
      <FeedbackIcon fontSize="large" color="primary" />
      <Typography variant="h5" gutterBottom>
        Feedback
      </Typography>
      <Typography variant="body2" color="textSecondary">
        View user feedback & reports
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 2 }}
        onClick={() => handleNavigation("/admin/feedback")}
      >
        Open
      </Button>
    </CardContent>
  </Card>
</Grid>

        {/* User Stats */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ textAlign: 'center', boxShadow: 4 }}>
            <CardContent>
              <GroupIcon fontSize="large" color="primary" />
              <Typography variant="h5" gutterBottom>
                {t("user_stats")}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {t("view_user_subscriptions_and_payments")}
              </Typography>
              <Button variant="contained" color="primary" sx={{ mt: 2 }}
                onClick={() => handleNavigation('/admin/users-stats')}>
                {t("user_stats")}
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Manager Product-General Product-ProductVariable */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ textAlign: 'center', boxShadow: 4 }}>
            <CardContent>
              <Inventory2Icon fontSize="large" color="primary" />
              <Typography variant="h5" gutterBottom>
                {t("products")}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {t("view_and_manage_all_products")}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                onClick={() => handleNavigation('/admin/products')}
              >
                {t("products")}
              </Button>
            </CardContent>
          </Card>
        </Grid>
        
        {/* Manage Products */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ textAlign: 'center', boxShadow: 4 }}>
            <CardContent>
              <Inventory2Icon fontSize="large" color="primary" />
              <Typography variant="h5" gutterBottom>
                {t("manage_products")}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {t("add_or_update_products_in_the_system")}
              </Typography>
              <Button variant="contained" color="primary" sx={{ mt: 2, mr: 1 }}
                onClick={() => handleNavigation('/admin/add-product')}>
                {t("add_product")}
              </Button>
              <Button variant="contained" color="secondary" sx={{ mt: 2, ml: 1 }}
                onClick={() => handleNavigation('/admin/update-product')}>
                {t("update_product")}
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Generic Products */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ textAlign: 'center' }}>
            <CardContent>
              <WidgetsIcon fontSize="large" color="success" />
              <Typography variant="h5" gutterBottom>
                {t("manage_generic_products")}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {t("add_or_update_products_in_the_system")}
              </Typography>
              <Button variant="contained" color="success" sx={{ mt: 2, mr: 1 }}
                onClick={() => handleNavigation('/admin/add-generic-product')}>
                {t("add_generic_product")}
              </Button>
              <Button variant="contained" color="secondary" sx={{ mt: 2, ml: 1 }}
                onClick={() => handleNavigation('/admin/update-generic-product')}>
                {t("update_generic_product")}
              </Button>
            </CardContent>
          </Card>
        </Grid>
        
        {/* Product Variants */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ textAlign: 'center' }}>
            <CardContent>
              <CategoryIcon fontSize="large" color="info" />
              <Typography variant="h5" gutterBottom>
                {t("manage_product_variants")}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {t("add_or_update_product_variants")}
              </Typography>
              <Button variant="contained" color="info" sx={{ mt: 2, mr: 1 }}
                onClick={() => handleNavigation('/admin/add-variant-product')}>
                {t("add_variant_product")}
              </Button>
              <Button variant="contained" color="secondary" sx={{ mt: 2, ml: 1 }}
                onClick={() => handleNavigation('/admin/update-variant-product')}>
                {t("update_variant_product")}
              </Button>
            </CardContent>
          </Card>
        </Grid>

        {/* Add Recipe */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ textAlign: 'center' }}>
            <CardContent>
              <RestaurantMenuIcon fontSize="large" color="warning" />
              <Typography variant="h5" gutterBottom>
                {t("add_recipe")}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {t("create_and_manage_recipes")}
              </Typography>
              <Button variant="contained" color="warning" sx={{ mt: 2 }}
                onClick={() => handleNavigation('/admin/add-recipe')}>
                {t("add_recipe")}
              </Button>
            </CardContent>
          </Card>
        </Grid>

       {/* Update Recipe */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ textAlign: 'center' }}>
            <CardContent>
              <EditNoteIcon fontSize="large" color="error" />
              <Typography variant="h5" gutterBottom>
                {t("update_recipe")}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {t("edit_and_update_existing_recipes")}
              </Typography>
              <Button variant="contained" color="error" sx={{ mt: 2 }}
                onClick={() => handleNavigation('/admin/update-recipe/0')}>
                {t("update_recipe")}
              </Button>
            </CardContent>
          </Card>
        </Grid>



        {/* Add Admin Card */}
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ textAlign: 'center' }}>
            <CardContent>
              <PersonAddIcon fontSize="large" color="secondary" />
              <Typography variant="h5" gutterBottom>
                {t("add_admin")}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {t("create_new_admin_users")}
              </Typography>
              <Button variant="contained" color="secondary" sx={{ mt: 2 }}
                onClick={() => handleNavigation('/admin/add-admin')}>
                {t("add_admin")}
              </Button>
            </CardContent>
          </Card>
        </Grid>

      </Grid>
    </Container>
  );
};

export default AdminDashboard;
